import { Config } from '@comall-backend-builder/core/lib/parser'; //
export let config: Config = {
    entities: {
        deliveryOrder: {
            apiPath: '/loader/find-delivery-page',
            properties: {
                expressName: {
                    type: 'string',
                    displayName: '快递公司',
                },
                expressNumber: {
                    type: 'string',
                    displayName: '快递单号',
                },
                orderNo: {
                    type: 'string',
                    displayName: '订单编码',
                },
                updateTimeStr: {
                    type: 'string',
                    displayName: '发货时间',
                },
                orderType: {
                    type: 'string',
                    displayName: '订单类型',
                },
                receiverName: {
                    type: 'string',
                    displayName: '收货人姓名',
                },
                mobile: {
                    type: 'string',
                    displayName: '收货人手机号',
                },
                address: {
                    type: 'string',
                    displayName: '详细地址',
                },
                printTimes: {
                    type: 'number',
                    displayName: '打印次数',
                },
            },
            filters: {
                express_number: {
                    type: 'string',
                    displayName: '快递单号',
                    controlConfig: {
                        placeholder: '快递单号',
                    },
                },
                order_no: {
                    type: 'string',
                    displayName: '订单编号',
                    controlConfig: {
                        placeholder: '订单编号',
                    },
                },
                update_time: {
                    type: 'object.dateRange',
                    displayName: '发货时间',
                },
                order_type: {
                    type: 'string.options.select',
                    displayName: '订单类型',
                    controlConfig: {
                        placeholder: '订单类型',
                    },
                    options: [],
                    source: {
                        apiPath: '/shippingOrderNew/order_type_enum',
                    },
                },
                printed: {
                    type: 'string.options.select',
                    displayName: '面单是否打印',
                    controlConfig: {
                        placeholder: '面单是否打印',
                    },
                    options: [
                        {
                            id: '__ALL__',
                            name: '全部',
                        },
                        {
                            id: 'Y',
                            name: '已打印',
                        },
                        {
                            id: 'N',
                            name: '未打印',
                        },
                    ],
                },
            },
        },
    },
    components: {
        DeliveryOrderView: {
            component: 'Card',
            title: '快递面单打印',
            entity: 'deliveryOrder',
            content: {
                component: 'FlexLayout',
                direction: 'vertical',
                align: 'justify',
                items: [
                    {
                        component: 'deliveryOrderFilter',
                    },
                    {
                        component: 'DeliveryOrder',
                    },
                ],
            },
        },

        deliveryOrderFilter: {
            component: 'FilterFormPlus',
            direction: 'horizontal',
            labelCol: 8,
            style: {
                marginBottom: 1,
            },
            fields: [
                {
                    property: 'express_number',
                    controlConfig: {
                        style: { width: 50 },
                    },
                },
                {
                    property: 'order_no',
                    controlConfig: {
                        style: { width: 50 },
                    },
                },
                {
                    property: 'update_time',
                },
                {
                    property: 'order_type',
                    controlConfig: {
                        style: { width: 50 },
                    },
                },
                {
                    property: 'printed',
                    controlConfig: {
                        style: { width: 50 },
                    },
                },
            ],
            fieldRow: {},
            fieldCol: {
                span: 8,
            },
            footer: {
                style: {
                    textAlign: 'right',
                },
            },
            submit: {
                text: '查询',
            },
            reset: true,
        },
    },

    routes: [
        {
            path: '/',
            childRoutes: [
                {
                    path: '/trade',
                    component: 'Viewport',
                    breadcrumbName: '交易管理',
                    childRoutes: [
                        {
                            path: '/deliveryOrder',
                            component: 'DeliveryOrderView',
                            breadcrumbName: '快递面单打印',
                        },
                    ],
                },
            ],
        },
    ],
};
